import React, { useState } from "react";
import toast from "react-hot-toast";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import StarRating from "./UserPatientScreen/StarRating";
import "./RatingModal.css";

const RatingModal = ({ isOpen, onClose, booking, onSuccess }) => {
    const [ratingStar, setRatingStar] = useState(0);
    const [description, setDescription] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (!isOpen || !booking) return null;

    const handleSubmit = async (method) => {
        if (method === "submit" && ratingStar === 0) {
            toast.error("Please select a star rating first.");
            return;
        }

        setIsSubmitting(true);

        try {
            const payload = {
                booking_id: booking.booking_id,
                provider_id: booking.provider_id,
                rating_star: method === "submit" ? ratingStar : 0,
                description: method === "submit" ? description : "",
                method: method, // "submit" or "skip"
            };

            const res = await axiosReqConfig(`${API_IP}/api/rating`, "patch", payload);

            if (res.ok) {
                toast.success(method === "submit" ? "Rating submitted successfully!" : "Rating skipped.");
                onSuccess(); // Triggers the unrated bookings refresh in parent
                handleClose();
            }
        } catch (error) {
            console.error("Error submitting rating:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        setRatingStar(0);
        setDescription("");
        onClose();
    };

    return (
        <div className="RM-overlay">
            <div className="RM-modal">
                <h3 className="RM-title">Rate Your Provider</h3>
                <p className="RM-subtitle">
                    How was your experience with <strong>{booking.provider_name}</strong>?
                </p>

                <StarRating
                    rating={ratingStar}
                    interactive={true}
                    onRatingChange={setRatingStar}
                />

                <textarea
                    className="RM-textarea"
                    placeholder="Leave a comment about the service (optional)..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    disabled={isSubmitting}
                />

                <div className="RM-actions">
                    <button
                        className="RM-btn RM-btn-cancel"
                        onClick={handleClose}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        className="RM-btn RM-btn-skip"
                        onClick={() => handleSubmit("skip")}
                        disabled={isSubmitting}
                    >
                        Skip
                    </button>
                    <button
                        className="RM-btn RM-btn-submit"
                        onClick={() => handleSubmit("submit")}
                        disabled={isSubmitting || ratingStar === 0}
                    >
                        {isSubmitting ? "Submitting..." : "Submit Rating"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RatingModal;